import { render } from "./Punctuality.vue?vue&type=template&id=62b0609f"
import script from "./Punctuality.vue?vue&type=script&lang=js"
export * from "./Punctuality.vue?vue&type=script&lang=js"
script.render = render

export default script